<template>
  <section data-testid="category-empty-state" class="flex flex-col items-center @md:mt-16">
    <NuxtImg
      src="/_nuxt-plenty/images/something-went-wrong.svg"
      :alt="t('search.emptyStateImageAlt')"
      width="192"
      height="192"
      loading="lazy"
    />
    <p class="mt-8 font-medium">{{ t('search.emptyStateText') }}</p>
    <p class="mt-4">{{ t('search.emptyStateText2') }}</p>
    <UiButton :tag="NuxtLink" :to="localePath(paths.category)" variant="secondary" class="mt-4">
      {{ t('product.allProductsLink') }}
    </UiButton>
  </section>
</template>

<script setup lang="ts">
import { paths } from '~/utils/paths';

const localePath = useLocalePath();
const NuxtLink = resolveComponent('NuxtLink');
</script>
